// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forecast-boxes-table-row {
  width: 100%;
  height: fit-content;
  min-height: 13%;
  display: grid;
  flex-direction: row;
  border-bottom: 0.7px solid #DBDBDB;
  justify-content: center;
  align-items: self-start;
  padding: 10px 1rem;
  grid-template-columns: 40% 20% 20% 20%;
  place-items: center;
}
.forecast-boxes-table-row__label {
  font-weight: bold;
  font-size: 0.85rem;
  justify-self: start;
  padding-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/forecast-boxes-table-row/forecast-boxes-table-row.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AACJ;AACI;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AACR","sourcesContent":[".forecast-boxes-table-row{\n    width: 100%;\n    height: fit-content;\n    min-height: 13%;\n    display: grid;\n    flex-direction: row;\n    border-bottom: 0.7px solid #DBDBDB;\n    justify-content: center;\n    align-items: self-start;\n    padding: 10px 1rem;\n    grid-template-columns: 40% 20% 20% 20%;\n    place-items: center;\n    \n    &__label{\n        font-weight: bold;\n        font-size: 0.85rem;\n        justify-self: start;\n        padding-left: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
